import React, { Component } from 'react';
import axios from 'axios';
import Serverurl from './Apiurl';
import {
  Button,
  Typography,
  Box,
  TablePagination,
  TextField,
  Card,
  Drawer,
  IconButton
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { NavLink, Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import PhoneIcon from '@mui/icons-material/Phone';
import editIconImg from './images/edit.png';
import deleteIconImg from './images/delete.png';


const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


class InvoiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      searchText: '',
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedInvoices: [],
      status: '',
      openFilter: false,
      filterStatus: '',
      fromDate: '',
      toDate: ''
    };
  }


  componentDidMount() {
    if (!localStorage.getItem("GBuserid")) {
      this.setState({
        redirect: true,
        pagename: '/Businesslogin'
      });
    }

    this.fetchInvoices();
  }


  fetchInvoices = () => {
    const bu_id = localStorage.getItem("GBuserid");

    axios.get(
      Serverurl +
      "ajaxinvoice.php?action=getallinvoice" +
      "&StartIndex=" + this.state.page +
      "&PageSize=" + this.state.rowsPerPage +
      "&cu_name=" + this.state.searchText +
      "&in_status=" + this.state.filterStatus +
      "&in_fromdate=" + this.state.fromDate +
      "&in_todate=" + this.state.toDate +
      "&in_bu_id=" + bu_id
    )
      .then((res) => {

        const invoices = res.data || [];

        const totalItems = parseInt(
          invoices[0]?.total || invoices.length
        );

        this.setState({
          invoices,
          totalItems
        });

      });
  };


  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  };


  searchInvoices = () => {
    this.setState(
      { page: 0 },
      this.fetchInvoices
    );
  };


  onPageChange = (event, newPage) => {
    this.setState(
      { page: newPage },
      this.fetchInvoices
    );
  };


  onRowsPerPageChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      this.fetchInvoices
    );
  };


  handleSelectInvoice = (in_id) => {
    this.setState((prev) => ({
      selectedInvoices: prev.selectedInvoices.includes(in_id)
        ? prev.selectedInvoices.filter((x) => x !== in_id)
        : [...prev.selectedInvoices, in_id]
    }));
  };


  handleStatusChange = (e) => {
    this.setState({
      status: e.target.value
    });
  };


  updateStatus = () => {
    const {
      selectedInvoices,
      status,
      invoices
    } = this.state;

    const formData = new FormData();

    selectedInvoices.forEach((in_id) => {
      formData.append('in_id[]', in_id);
    });

    formData.append('in_status', status);
    formData.append("action", "invoicestatus");

    axios.post(
      Serverurl + "ajaxinvoice.php",
      formData
    )
      .then((res) => {

        const updatedInvoices = invoices.map(item =>
          selectedInvoices.includes(item.in_id)
            ? {
                ...item,
                in_status: status
              }
            : item
        );

        this.setState({
          invoices: updatedInvoices,
          selectedInvoices: [],
          status: ''
        });

      });
  };


  toggleFilter = (open) => {
    this.setState({
      openFilter: open
    });
  };


  handleFilterChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };


  applyFilter = () => {
    this.setState(
      { page: 0 },
      () => {
        this.fetchInvoices();
        this.toggleFilter(false);
      }
    );
  };


 /* generateInvoicePdf = (in_id) => {
    this.props.navigate("/invoice/view/" + in_id);
  };*/
generateInvoicePdf = (in_id) => {
    this.props.navigate(
        "/invoice/view/" + in_id + "?source=invoice"
    );
};

  // Edit Action
  editInvoice = () => {
    const {
      selectedInvoices
    } = this.state;

    if (selectedInvoices.length === 1) {
      this.props.navigate(
        "/invoice/edit/" + selectedInvoices[0]
      );
    } else {
      alert("Please select exactly one invoice to edit.");
    }
  };


  // Delete Action
deleteInvoices = () => {
  const { selectedInvoices } = this.state;

  if (selectedInvoices.length !== 1) {
    alert("Please select exactly one invoice to delete.");
    return;
  }

  if (!window.confirm("Are you sure you want to delete this invoice?")) {
    return;
  }

  const bu_id = localStorage.getItem("GBuserid");

  const formData = new FormData();

  formData.append("in_id", selectedInvoices[0]);
  formData.append("userid", bu_id);
  formData.append("action", "delete");

  axios
    .post(Serverurl + "ajaxinvoice.php", formData)
    .then((res) => {
      console.log("DELETE RESPONSE:", res.data);

      this.setState(
        {
          selectedInvoices: [],
        },
        this.fetchInvoices
      );
    })
    .catch((error) => {
      console.error("DELETE ERROR:", error);
      alert("Delete failed.");
    });
};



  render() {

    const {
      invoices,
      selectedInvoices
    } = this.state;

    return (
      <Box sx={{ p: 2 }}>


        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >

            <ChevronLeftIcon
              className="global-back-arrow"
              onClick={() => window.history.back()}
            />

            <Typography variant="h6">
              Invoices
            </Typography>

          </Box>


          <IconButton
            onClick={() => this.toggleFilter(true)}
            sx={{ p: 1 }}
          >

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: "5px",
              }}
            >

              <Box
                sx={{
                  width: "30px",
                  height: "4px",
                  bgcolor: "#000",
                  borderRadius: "2px"
                }}
              />

              <Box
                sx={{
                  width: "22px",
                  height: "4px",
                  bgcolor: "#000",
                  borderRadius: "2px"
                }}
              />

            </Box>

          </IconButton>

        </Box>


        <Box sx={{ mb: 2 }}>

          <TextField
            fullWidth
            placeholder="Search by Name / Phone / Email"
            value={this.state.searchText}
            onChange={this.handleSearchChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.searchInvoices();
              }
            }}
            sx={{
              bgcolor: "#f0f4f7",
              borderRadius: "30px",

              "& .MuiOutlinedInput-root": {
                borderRadius: "30px",
                pr: 0.5,
                pl: 2,
                height: "45px",
                marginRight: "-2px !important",

                "& fieldset": {
                  borderColor: "#cccccc",
                },

                "&:hover fieldset": {
                  borderColor: "#0f3a7d",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#0f3a7d",
                },
              },

              "& .MuiInputBase-input": {
                fontSize: "13px",
              },
            }}

            InputProps={{
              endAdornment: (

                <IconButton
                  onClick={this.searchInvoices}
                  sx={{
                    bgcolor: "#11408f",
                    color: "#ffffff",
                    width: "54px",
                    marginRight: "-2px !important",
                    height: "44px",

                    "&:hover": {
                      bgcolor: "#0b2b5c",
                    },
                  }}
                >

                  <SearchIcon
                    sx={{
                      fontSize: "20px"
                    }}
                  />

                </IconButton>

              ),
            }}
          />

        </Box>


        <Box
          sx={{
            display: 'flex',
            gap: 3,
            mb: 2
          }}
        >

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >

            <Box
              sx={{
                width: 35,
                height: 35,
                bgcolor: '#d5dde0',
                borderRadius: '5px'
              }}
            />

            <Typography
              variant="body2"
              sx={{ pb: 0 }}
            >
              Pending
            </Typography>

          </Box>


          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >

            <Box
              sx={{
                width: 35,
                height: 35,
                bgcolor: '#aac6ee',
                borderRadius: '5px'
              }}
            />

            <Typography
              variant="body2"
              sx={{ pb: 0 }}
            >
              Approved
            </Typography>

          </Box>


          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >

            <Box
              sx={{
                width: 35,
                height: 35,
                bgcolor: '#dcdaef',
                borderRadius: '5px'
              }}
            />

            <Typography
              variant="body2"
              sx={{ pb: 0 }}
            >
              Rejected
            </Typography>

          </Box>

        </Box>


        {selectedInvoices.length > 0 && (

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mb: 2
            }}
          >

            <TextField
              select
              size="small"
              value={this.state.status}
              onChange={this.handleStatusChange}
              SelectProps={{
                native: true
              }}
            >

              <option value="">
                Select Status
              </option>

              <option value="Pending">
                Pending
              </option>

              <option value="Approved">
                Approved
              </option>

              <option value="Rejected">
                Rejected
              </option>

            </TextField>


            <Button
              variant="contained"
              className="primartybtn"
              
              onClick={this.updateStatus}
            >
              Update
            </Button>

          </Box>

        )}


        <ul
          style={{
            listStyle: 'none',
            padding: 0
          }}
        >

          {invoices.length > 0 ? (

            invoices.map((item) => {

              const status = (item.in_status || '')
                .replace(/\s+/g, '')
                .toLowerCase();

              console.log("RAW STATUS:", item);

              return (

                <li
                  key={item.in_id}
                  style={{
                    marginBottom: 12
                  }}
                  className="invoice-list"
                >

                  <Card
                    sx={{
                      bgcolor:
                        status === 'approved'
                          ? '#aac6ee'
                          : status === 'rejected'
                          ? '#dcdaef'
                          : status === 'pending'
                          ? '#d5dde0'
                          : '#ffffff',

                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      p: 2,
                      cursor: 'pointer'
                    }}

                    onClick={() =>
                      this.generateInvoicePdf(item.in_id)
                    }
                  >

                    <input
                      type="checkbox"
                      checked={selectedInvoices.includes(item.in_id)}
                      onClick={(e) =>
                        e.stopPropagation()
                      }
                      onChange={() =>
                        this.handleSelectInvoice(item.in_id)
                      }
                    />


                    {/* Left Section */}

                    <Box flex={1}>

                      <Typography variant="h6">
                        {item.cu_name}
                      </Typography>


                      <Typography variant="body2">
                        {item.company_name}
                      </Typography>


                      <Box
                        sx={{
                          display: 'flex !important',
                          alignItems: 'center !important',
                          gap: 0.5
                        }}
                      >

                        <PhoneIcon
                          sx={{
                            fontSize: '15px',
                            color: '#000000',
                            marginTop: '-12px !important'
                          }}
                        />

                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '10px !important',
                          }}
                        >
                          | {item.phone_number}
                        </Typography>

                      </Box>

                    </Box>


                    {/* Right Section: Invoice Number, Date and Amount */}

                    <Box textAlign="right">

                      <Typography variant="subtitle1">
                        Invoice #{item.in_innumber || item.in_number || item.in_id}
                      </Typography>


                      <Typography variant="body2">
                        {formatDate(item.in_date)}
                      </Typography>


                      <Typography>
                        ₹ {item.in_roundofamount}
                      </Typography>

                    </Box>

                  </Card>

                </li>

              );

            })

          ) : (

            <Typography align="center">
              No invoices found
            </Typography>

          )}

        </ul>


        {/* --- ADD THE SNIPPET HERE --- */}

        {selectedInvoices.length > 0 && (

          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              gap: 1.5,
              mt: 2,
              mb: 1,
            }}
          >

            <Button
              variant="contained"

              endIcon={
                <img
                  src={editIconImg}
                  alt="Edit"
                  style={{
                    width: "28px",
                    objectFit: "contain"
                  }}
                />
              }

              onClick={this.editInvoice}

              disabled={
                selectedInvoices.length !== 1
              }

              sx={{
                bgcolor: "#13448d",
                color: "#ffffff",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "6px",
                px: 2,
                py: 0.6,
                boxShadow: "none",

                "&:hover": {
                  bgcolor: "#0086ba",
                  boxShadow: "none",
                },
              }}
            >
              Edit
            </Button>


            <Button
              variant="contained"

              endIcon={
                <img
                  src={deleteIconImg}
                  alt="Delete"
                  style={{
                    width: "28px",
                    objectFit: "contain"
                  }}
                />
              }

              onClick={this.deleteInvoices}

              sx={{
                bgcolor: "#dc1616",
                color: "#ffffff",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "6px",
                px: 2,
                py: 0.6,
                boxShadow: "none",

                "&:hover": {
                  bgcolor: "#dc2626",
                  boxShadow: "none",
                },
              }}
            >
              Delete
            </Button>

          </Box>

        )}


        {/* Pagination */}

        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          onPageChange={this.onPageChange}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.onRowsPerPageChange}
          rowsPerPageOptions={
            this.state.itemsPerPageOptions
          }
        />


        {/* Filter Drawer */}

        <Drawer
          anchor="right"
          open={this.state.openFilter}
          onClose={() =>
            this.toggleFilter(false)
          }
        >

          <Box
            sx={{
              width: 300,
              p: 2
            }}
          >

            <Typography
              variant="h6"
              mb={2}
            >
              Filter Invoices
            </Typography>


            <TextField
              select
              fullWidth
              size="small"
              name="filterStatus"
              value={this.state.filterStatus}
              onChange={this.handleFilterChange}
              SelectProps={{
                native: true
              }}
              sx={{
                mb: 2
              }}
            >

              <option value="">
                All
              </option>

              <option value="Pending">
                Pending
              </option>

              <option value="Approved">
                Approved
              </option>

              <option value="Rejected">
                Rejected
              </option>

            </TextField>


            <TextField
              fullWidth
              size="small"
              type="date"
              label="From Date"
              name="fromDate"
              value={this.state.fromDate}
              onChange={this.handleFilterChange}
              InputLabelProps={{
                shrink: true
              }}
              sx={{
                mb: 2
              }}
            />


            <TextField
              fullWidth
              size="small"
              type="date"
              label="To Date"
              name="toDate"
              value={this.state.toDate}
              onChange={this.handleFilterChange}
              InputLabelProps={{
                shrink: true
              }}
              sx={{
                mb: 2
              }}
            />


            <Button
              fullWidth
              variant="contained"
              className="primartybtn"
              onClick={this.applyFilter}
            >
              Apply
            </Button>

          </Box>

        </Drawer>


      </Box>
    );
  }
}


function InvoiceWithNavigate(props) {
  const navigate = useNavigate();

  return (
    <InvoiceList
      {...props}
      navigate={navigate}
    />
  );
}


export default InvoiceWithNavigate;
